import { render, staticRenderFns } from "./ZipFiles.vue?vue&type=template&id=0c6d1f21&scoped=true&"
import script from "./ZipFiles.vue?vue&type=script&lang=js&"
export * from "./ZipFiles.vue?vue&type=script&lang=js&"
import style0 from "./ZipFiles.vue?vue&type=style&index=0&id=0c6d1f21&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6d1f21",
  null
  
)

export default component.exports